import { GoogleRecaptchaSettings } from "@/modules/core/types";
import { defineStore } from "pinia";

export const useOccCommonDataStore = defineStore('occ-common-data', {
    state: () => ({
        googleRecaptchaSettings: null as GoogleRecaptchaSettings | null
    })
})
